import React, {FC, useState} from 'react';
import {Student, StudentSourceNameMap} from "../../../shared/types/student";
import {Teacher, TeacherRole} from "../../../shared/types/teacher";
import HLInfoRow, {HLInfoRowStyleType} from '../../../shared/components/info-row/HLInfoRow';
import HLButton, {HLButtonStyleType} from "../../../shared/components/button/HLButton";
import HLLine from "../../../shared/components/line/HLLine";
import UpdateStudentModal from "../../../modal/student/UpdateStudentModal";
import classes from "./StudentInfoCard.module.scss";

interface StudentInfoCardProps {
    student: Student;
    setStudent: (student: Student) => void;
    currentTeacher: Teacher | null;
}

const StudentInfoCard: FC<StudentInfoCardProps> = (
    {
        student,
        setStudent,
        currentTeacher
    }) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleEdit = () => {
        setIsEditModalOpen(true);
    };

    return (
        <div className={classes.contentContainer}>
            <h2 className={classes.formTitle}>Информация об ученике</h2>

            <HLInfoRow label="Имя:" value={student.firstName}/>
            <HLInfoRow label="Фамилия:" value={student.lastName || '-'}/>
            <HLInfoRow label="Telegram:" value={student.telegram || '-'}/>
            <HLInfoRow
                label="Статус:"
                value={student.enabled ? 'Активен' : 'Неактивен'}
                styleType={student.enabled ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}
            />
            <HLInfoRow label="Email:" value={student.email || '-'}/>

            {currentTeacher?.role === TeacherRole.ADMIN && <>
                <HLInfoRow label="Откуда пришёл:" value={StudentSourceNameMap[student.source]}/>

                <HLLine/>

                <HLButton
                    onClick={handleEdit}
                    styleType={HLButtonStyleType.ORANGE}
                >
                    Изменить
                </HLButton>
            </>}

            <UpdateStudentModal
                open={isEditModalOpen}
                setOpen={setIsEditModalOpen}
                student={student}
                setStudent={setStudent}
            />
        </div>
    );
};

export default StudentInfoCard; 